import CASL from '@/utils/constants/casl'

export default {
  path: 'payment-package-material',
  children: [
    {
      path: '',
      name: 'payment-package-material.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.PAKET_PEMBAYARAN_MATERIAL
      },
      component: () => import('./list/PaymentPackageMaterialListPage.vue')
    },
    {
      path: 'add',
      name: 'payment-package-material.add',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.PAKET_PEMBAYARAN_MATERIAL
      },
      component: () => import('./form/PaymentPackageMaterialFormPage.vue')
    },
    {
      path: ':uid',
      name: 'payment-package-material.edit',
      meta: {
        action: 'update',
        subject: CASL.ACCESS.PAKET_PEMBAYARAN_MATERIAL
      },
      component: () => import('./form/PaymentPackageMaterialFormPage.vue')
    }
  ]
}
